const localStorage = window.localStorage;

export const getCurrentSurvey = () => {
  return localStorage.getItem("crca-survey-id");
};

export const setCompleted = () => {
  const surveyId = getCurrentSurvey();
  localStorage.setItem(`crca-chat-completed-${surveyId}`, new Date().getTime());
};

export const getCompletedTime = () => {
  localStorage.getItem("crca-chat-completed");
};

export const isCompleted = (surveyId) => {
  const storageKey = surveyId ? `crca-chat-completed-${surveyId}` : `crca-chat-completed-${getCurrentSurvey()}`;
  if (!localStorage.getItem(storageKey)) return false;
  return new Date().getTime() - localStorage.getItem(storageKey) < 100800000; // 48 hours
};

export const setChatHistory = (surveyId, chatHistory) => {
  localStorage.setItem(`webtag_${surveyId}`, JSON.stringify(chatHistory));
};

export const getChatHistory = (surveyId) => {
  let chatHistory = localStorage.getItem(`webtag_${surveyId}`);
  return chatHistory ? JSON.parse(chatHistory) : {};
};

export const clearChatHistory = (surveyId) => {
  localStorage.removeItem(`webtag_${surveyId}`);
};

export const setCurrentSurvey = (surveyId) => {
  localStorage.setItem("crca-survey-id", surveyId);
};

export const isTargetedForConversation = (conversation) => {
  return localStorage.getItem(`crca-user-targeted-${conversation.website_configuration_id}-${conversation.id}`);
};

export const setIsTargetedForConversation = (isTargeted, conversation) => {
  localStorage.setItem(`crca-user-targeted-${conversation.website_configuration_id}-${conversation.id}`, isTargeted);
};
